import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import SignIn from './pages/SignIn';
import Services from './pages/Services';
import Bookings from './pages/Bookings';
import AddService from './pages/AddService';
import Profile from './pages/Profile';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';

const RoutesConfig = () => {
  return(
    <Router>
      <Routes>
        <Route path='/sign-in' element={ <SignIn /> } />
        <Route path='/' element={ <Bookings /> } />
        <Route path='/services' element={ <Services /> } />
        <Route path='/add-service' element={ <AddService /> } />
        <Route path='/edit-service/:id' element={ <AddService /> } />
        <Route path='/profile' element={ <Profile /> } />
        <Route path='/forgot-password' element={ <ForgotPassword /> } />
        <Route path='/reset-password/:token' element={ <ResetPassword /> } />
      </Routes>
    </Router>
  )
}

export default RoutesConfig;